<div class="container">
	<div class="top-container mt-5">
		<form
			class="form"
			#nameForm="ngForm"
			novalidate
			(ngSubmit)="saveNameForm(registrationPlates, vinNumber)"
		>
			<input
				class="mr-3"
				placeholder="Kërko numrin e targave të makinës…"
				[(ngModel)]="registrationPlates"
				name="plates"
				#plates="ngModel"
				nbInput
			/>
			<input
				placeholder="Kërko numrin VIN…"
				nbInput
				[(ngModel)]="vinNumber"
				name="vin"
				#vin="ngModel"
				nbInput
			/>
			<button
				id="button"
				type="submit"
				class="blue-button ml-2"
				routerLink="/scenario-fifth-results/{{ registrationPlates }}/{{
					vinNumber
				}}"
				[disabled]="vin.invalid || plates.invalid"
			>
				KËRKO
			</button>
		</form>
		<span
			id="button"
			class="text-danger ml-2 mt-4"
			*ngIf="plates && plates.invalid && plates.touched"
			>Ju lutem shkruani numrin përsonal për të vazhduar</span
		>
	</div>
	<div
		*ngIf="
			validityAccident !== undefined && validityAccident !== null;
			else noResults
		"
	>
		<nb-card class="green mt-5">
			<p>Të dhënat që ju keni kërkuar përputhen</p>
		</nb-card>
	</div>
	<div class="action-button d-flex">
		<button class="blue-button">
			SHKARKO
		</button>
	</div>
</div>

<ng-template #noResults>
	<div
		class="container p-0"
		*ngIf="validityAccident !== undefined; else loading"
	>
		<nb-card class="red mt-5">
			<p>Të dhënat që ju keni kërkuar nuk përputhen</p>
		</nb-card>
	</div>
</ng-template>

<ng-template #loading>
	<div
		class="loading"
		[nbSpinner]="loading"
		nbSpinnerSize="giant"
		nbSpinnerStatus="primary"
	></div>
</ng-template>
